import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "common/components/base/modal/Modal";
import Header from "common/components/base/header";
import Button from "common/components/base/button/Button";
import { ButtonType, ButtonVariant } from "common/enums/components/button.enum";
import { useAppDispatch } from "common/redux/core";
import { userActions } from "common/redux/user";
import { LogoutType } from "common/enums/logout-type.enum";
import labelCollection from "modules/_shared/config/langauge-keys.config";
import { useNewSessionMutation } from "common/redux/user/mutations";

import "./ConcurrentSessionModal.scss";

interface ConcurrentSessionModalProps {
  showModal: boolean;
  onCloseClick: () => void;
}

const ConcurrentSessionModal: FC<ConcurrentSessionModalProps> = ({
  showModal,
  onCloseClick
}) => {
  const { t } = useTranslation(["concurrentSession"]);
  const dispatch = useAppDispatch();

  const [newSession, { isSuccess: isNewSessionSucess }] =
    useNewSessionMutation();

  useEffect(() => {
    if (isNewSessionSucess) {
      sessionStorage.clear();
      localStorage.clear();
      // Reload the current URL (including hash route) so the user stays on
      // the page they originally hit instead of being sent to the landing page.
      // window.location.href = window.location.origin; // landing page
      window.location.reload();
    }
  }, [isNewSessionSucess]);

  const handleLogout = () => {
    dispatch(userActions.hasUserLoggedOut(true));
    dispatch(userActions?.userLogoutType(LogoutType.SESSION_TIMEOUT));
    onCloseClick();
  };

  const handleContinue = () => {
    newSession({});
  };

  return (
    <Modal
      className="concurrent-session-modal"
      show={showModal}
      takeover
      title={""}
      onClose={() => onCloseClick()}
      bodyElement={
        <>
          <Header hideContainer={true} />

          <div className="concurrent-session-modal__body">
            <p className="content-title">
              {t(labelCollection.multipleActiveSessions)}
            </p>
            <p className="content-body">{t(labelCollection.message)}</p>

            <Button
              className="btn-contiue"
              variant={ButtonVariant.PRIMARY}
              type={ButtonType.BUTTON}
              size="medium"
              onClick={handleContinue}
            >
              {t(labelCollection.contnue)}
            </Button>

            <Button
              className="btn-logout"
              variant={ButtonVariant.TEXT}
              type={ButtonType.BUTTON}
              onClick={handleLogout}
            >
              {t(labelCollection.cancel)}
            </Button>
          </div>
        </>
      }
    />
  );
};

export default ConcurrentSessionModal;
